import React, { useEffect, Fragment } from 'react';
import { withRouter } from 'react-router-dom';

const ScrollToTop = ({ history, children }) => {
   useEffect(() => {
      const unlisten = history.listen(() => {
         if (history.location.pathname !== '/shoppingcart') window.scrollTo(0, 0);
      });
      return () => {
         unlisten();
      };
   }, [history]);

   return <Fragment>{children}</Fragment>;
};

export default withRouter(ScrollToTop);
